import { render } from "./CheckTrialPeriodPropsCmp.vue?vue&type=template&id=36b71072"
import script from "./CheckTrialPeriodPropsCmp.vue?vue&type=script&lang=js"
export * from "./CheckTrialPeriodPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__